import { http } from "@api/client";
import { pickResult } from "@api/utils";
import axios from "axios";

export function getS3Modules() {
  return http.get(`/ingestion/modules`).pipe(pickResult());
}

export function getFiles(module: string) {
  return http.get(`/ingestion/${module}/files?folder=input,error,output`).pipe(pickResult());
}

export function getUploadUrl(moduleName: string, fileName: string) {
  return http.get(
    `/ingestion/${moduleName}/upload-url`,
    {
      params: {
        file_name: fileName,
      },
    }
  ).pipe(pickResult());
}

export const uploadToS3 = async (
  signedUrl: string,
  file: File
) => {
  return axios.put(
    signedUrl,
    file,
    {
      headers: {
        'Content-Type':
          'binary/octet-stream',
      },
    }
  );
};

export function getDownloadUrl(
  moduleName: string,
  fileName: string,
  folder: string
) {
  return http
    .get(
      `/ingestion/${moduleName}/download-url`,
      {
        params: {
          file_name: fileName,
          folder,
        },
      }
    )
    .pipe(pickResult());
}

export function getExecutionStatus(moduleName: string) {
  return http
    .get(`/ingestion/${moduleName}/execution-status`)
    .pipe(pickResult());
}